import { Teaser } from '../../../utility/types/components/types';

(function () {
    var teaser: Teaser = {
        vPort: 'screen-md',
        isMobile: false,
        init: function () {
            teaser.controls();
            teaser.truncate();
        },
        controls: function () {
            $(document).on(UX.teaser.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                teaser.isMobile = true;
                teaser.truncate();
            });

            $(document).on(UX.teaser.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                teaser.isMobile = false;
            });
        },
        truncate: function () {
            $('.teaser__item__authors .loa').not("[data-truncate='none']").truncate({
                type: 'list',
                position: 'betweenFirstAndLast',
                lines: 1,
                seeMoreText: '',
                seeLessText: '',
                seeMoreHtml: '',
                ellipsisChar: '[&hellip;]',
                addClass: 'author-truncated',
            });

            if (teaser.isMobile) {
                $('.teaser__item__title h6').not("[data-truncate='none']").truncate({
                    type: 'text',
                    position: 'end',
                    lines: 2,
                    seeMoreText: '',
                    seeLessText: '',
                    seeMoreHtml: '',
                    ellipsisChar: '&hellip;',
                    isMobile: true,
                    isSliding: false,
                });
            } else {
                $('.teaser__item__title h6').not("[data-truncate='none']").truncate({
                    type: 'text',
                    position: 'end',
                    lines: 4,
                    seeMoreText: '',
                    seeLessText: '',
                    seeMoreHtml: '',
                    ellipsisChar: '&hellip;',
                    isMobile: true,
                    isSliding: false,
                });
            }
        },
    };
    UX.teaser = teaser;
})();
